// extracted by mini-css-extract-plugin
export default {"table":"ItemTable_table__H+8Oh","mobileItem":"ItemTable_mobileItem__VjaMv","th":"ItemTable_th__c-uM5","td":"ItemTable_td__MVSNd","oddRow":"ItemTable_oddRow__byExJ"};